import VueLazyload from "vue-lazyload";

/** 提前加载距离（相对视口高度的倍数），约 50% 视口高度外开始加载 */
const PRELOAD_RATIO = 1.5;
/** 背景图 IntersectionObserver 的提前距离（px） */
const BG_ROOT_MARGIN = "400px 0px";

/**
 * 为 CSS 背景图懒加载：接近视口时给元素加上 is-lazy-bg-loaded，
 * 样式里把 background-image 写在 .is-lazy-bg-loaded 下即可避免首屏外请求。
 */
function installLazyBg(Vue) {
  const observe = (el) => {
    if (el._lazyBgObserved) return;
    el._lazyBgObserved = true;

    if (!("IntersectionObserver" in window)) {
      el.classList.add("is-lazy-bg-loaded");
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          el.classList.add("is-lazy-bg-loaded");
          io.unobserve(el);
          io.disconnect();
          el._lazyBgIo = null;
        });
      },
      {
        root: null,
        rootMargin: BG_ROOT_MARGIN,
        threshold: 0,
      }
    );

    el._lazyBgIo = io;
    io.observe(el);
  };

  Vue.directive("lazy-bg", {
    inserted(el) {
      observe(el);
    },
    componentUpdated(el) {
      if (!el.classList.contains("is-lazy-bg-loaded")) {
        observe(el);
      }
    },
    unbind(el) {
      if (el._lazyBgIo) {
        el._lazyBgIo.disconnect();
        el._lazyBgIo = null;
      }
    },
  });
}

export function setupLazyload(Vue) {
  Vue.use(VueLazyload, {
    preLoad: PRELOAD_RATIO,
    attempt: 1,
    // 透明占位，避免依赖不存在的 /static/images/load.gif
    loading:
      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
    error:
      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
    observer: true,
    observerOptions: {
      rootMargin: BG_ROOT_MARGIN,
      threshold: 0,
    },
  });

  installLazyBg(Vue);
}
